import { useLocation } from 'react-router-dom';

export const useGetPilotNameFromUrl = () => {
    const location = useLocation();
    const pathParts = location.hash.split('/').filter(Boolean);
    const pilotName = pathParts[pathParts.length - 1];

    return { pilotName };
}
